<script setup lang="ts">
// Overrides @basecom-gmbh/pond/components/Utility/UtilityToastNotifications.vue
//IDS-177 - change toast position to top
const { notifications } = useNotifications();
</script>

<template>
    <div class="fixed right-5 top-10 z-50 flex max-h-fit w-96 max-w-[calc(100vw-2.5rem)] flex-col gap-2.5">
        <UtilityToastNotification
            v-for="notification in notifications"
            :key="notification.id"
            :notification="notification"
        />
    </div>
</template>
